export {startTimer, clearTimer, inViewport} from './functions';
export {decodeEntities} from './html-entities';
